// import PaymentMethodSelector from 'yinzhilv-js-sdk/frontend/common-project/component/yinzhilv/payment-method-selector/1.0.15/index.vue';
import PaymentMethodSelector
    from 'yinzhilv-js-sdk/frontend/common-project/component/yinzhilv/payment-method-selector/1.0.21/index.vue';

export default PaymentMethodSelector
